import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setAuthView, setForgotUsername, setPrefilledUsername, setUsernames } from '../../redux/slice/authModalSlice';
import { Images } from '../../utils/imageConstants';

const MultipleUsers: React.FC = () => {
  const dispatch = useAppDispatch();
  const { usernames, emailForReset } = useAppSelector((s) => s.authModal);
  const [selectedUsername, setSelectedUsername] = useState<string>('');

  useEffect(() => {
    // Set first username as selected when component mounts
    if (usernames && usernames.length > 0) {
      setSelectedUsername(usernames[0]);
    } else {
      // If no usernames, redirect back
      dispatch(setAuthView('forgot'));
    }
  }, [usernames, dispatch]);

  const handleBack = () => {
    dispatch(setAuthView('forgot'));
  };

  const handleContinue = () => {
    // Store selected username and navigate back to login
    dispatch(setPrefilledUsername(selectedUsername));
    dispatch(setForgotUsername(false));
    dispatch(setUsernames(undefined));
    dispatch(setAuthView('signin'));
  };

  // If no usernames, don't render
  if (!usernames || usernames.length === 0) {
    return null;
  }

  return (
    <div className="figma-login-container">
      <div className="login-background-image">
        <div className="login-modal-container">
          <div className="login-header">
            <div className="logo-container">
              <img src={Images.main_logo} alt="CRICCENTER" className="logo" />
            </div>
            <h1 className="app-name">CRICCENTER</h1>
          </div>
          
          <h2 className="signin-title">Select Username</h2>
          
          <div className="login-form">
            <div className="form-group">
              <label htmlFor="usernameSelect" className="form-label">
                Username
              </label>
              <div className="input-wrapper">
                <select
                  id="usernameSelect"
                  className="form-input"
                  value={selectedUsername}
                  onChange={(e) => setSelectedUsername(e.target.value)}
                >
                  {usernames?.map((username) => (
                    <option key={username} value={username}>
                      {username}
                    </option>
                  ))}
                </select>
              </div>
              {emailForReset && (
                <p className="form-helper-text" style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
                  Email: {emailForReset}
                </p>
              )}
            </div>
            
            <div className="action-buttons">
              <button 
                type="button" 
                className="btn-primary" 
                onClick={handleContinue}
              >
                Continue to Sign In
              </button>
              
              <button 
                type="button" 
                className="btn-secondary"
                onClick={handleBack}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultipleUsers;

